import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { triggerPublicEvent, PublicEvents } from '@project/shared/utils/events/js/events';

const classes = {
	checkboxElement: 'js-a-input-checkbox__input',
};

@createModule('InputCheckbox')
/**
 * input-checkbox module implementation.
 *
 * @author Robert Schork <robert.schork@namics.com>
 */
export class InputCheckbox extends TerrificSpec {
	start(resolve: Function) {
		const $ctx = $(this._ctx);

		let checkboxElement = $(`.${classes.checkboxElement}`, $ctx);

		checkboxElement.change(() => {
			this._triggerChangeEvent(checkboxElement.is(':checked'));
		});
		resolve();
	}
	stop() {}
	_triggerChangeEvent(isChecked: boolean) {
		triggerPublicEvent(PublicEvents.uxChange, this, this._ctx, isChecked);
	}
}
